<div class="message message--{{ cardClass }}">
  <div class="message__content" [ngClass]="{ 'message__content--small': size === 'small' }">
    <ng-content select="[message-content]"></ng-content>
  </div>
</div>
